<template>
  <v-btn
    :large="!$vuetify.breakpoint.mdAndDown"
    class="ml-3"
    style="height: 56px !important"
    depressed
    rounded
    outlined
    :loading="clickLimitStatus"
    :color="
      $store.state.riskLoading || clickLimitStatus ? 'primary' : $store.state.riskDur == 0 ? 'success' : 'tertiary'
    "
    dark
    @click="clickLimit"
  >
    <v-icon :size="36" class="me-2">
      {{ icons.mdiFinance }}
    </v-icon>
    <div class="text-left">
      <div class="text-subtitle-1 text-capitalize" style="line-height: 1.25">
        <span v-if="$store.state.riskLoading">Yükleniyor</span>
        <span v-else>{{ $store.state.riskTutar | currency({ fractionCount: 0 }) }}</span>
      </div>

      <div class="text--secondary font-weight-regular" style="font-size: 10px">Kalan Limit</div>
    </div>
  </v-btn>
</template>

<script>
import { ref } from "@vue/composition-api";
import store from "@/store";
import { postData } from "@utils";
import { mdiFinance } from "@mdi/js";
export default {
  setup() {
    const clickLimitStatus = ref(false);
    const clickLimit = () => {
      clickLimitStatus.value = true;
      postData({
        method: "updateCustomerLimit",
      }).then((responsee) => {
        if (responsee.error) {
          const dataRisk = {
            method: "riskOrderCalculate",
          };
          store.commit("RISK_LOADING", true);

          store.dispatch("postMethod", dataRisk).then((response) => {
            if (response.error == 0) {
              store.commit("RISK_TUTAR", response.detail.calculatedRisk);
              store.commit("RISK_DUR", response.detail.stopOrdering);
              store.commit("RISK_LOADING", false);
              setTimeout(() => {
                clickLimitStatus.value = false;
              }, 600);
            }
          });
        }
      });
    };

    return {
      clickLimitStatus,
      clickLimit,
      icons: {
        mdiFinance,
      },
    };
  },
};
</script>

<style></style>
